// Accounting Purchases Vuex

import state from './purchaseStates.js'
import * as getters from './purchaseGetters.js'
import * as mutations from './purchaseMutations.js'
import * as actions from './purchaseActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
